
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SET_MANAGER_ACCESSED_TO_CONTRACTOR from "@/apollo/managers/AddContractorToManagers.gql";

  import UIButton from "@/components/button/ui-button.vue";
  import AddEmployeeModal from "@/components/common/AddEmployeeModalNew.vue";
  import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
  import PlusIcon from "@/components/icons/PlusIcon.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
  import { NOTIFICATION } from "@/entities/Events";

  import Message from "@/data/notificationsMessages";

  interface contractorAddedToManagers {
    contractor_id: string;
    manager_id: string;
  }

  @Component({
    components: {
      UIButton,
      UiButtonMessage,
      AddEmployeeModal,
      ContractorsMultiselect,
      PlusIcon,
    },
  })
  export default class AddContractorToManager extends Vue {
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly managerId!: string;
    @Prop({ type: String, default: undefined }) readonly buttonSize?: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;

    conditions: Object = {
      _and: [
        {
          deleted: {
            _eq: false,
          },
        },
        {
          approved: {
            _eq: true,
          },
        },
        {
          _or: [
            {
              _not: {
                managers: {
                  manager_id: { _eq: this.managerId },
                },
              },
            },
            {
              managers: {
                approved: { _eq: false },
              },
            },
          ],
        },
      ],
    };

    modalShown: boolean = false;
    selectedContractorsIds: string[] = [];

    get isSelected(): boolean {
      return this.selectedContractorsIds.length > 0;
    }

    showModal(): void {
      this.modalShown = true;
    }

    closeModal(): void {
      this.modalShown = false;
    }

    contractorAddedToManager(): void {
      this.closeModal();
      this.selectedContractorsIds = [];
      this.$emit("contractorWasAddedToManager");
    }

    async addContractorToManagers(): Promise<void> {
      const contractorAddedToManagers = this.selectedContractorsIds.map((contractorId) => ({
        manager_id: this.managerId,
        contractor_id: contractorId,
        approved: true,
        created_by: this.currentUserId,
      }));

      try {
        await this.setManagerAccessToContractor(contractorAddedToManagers);

        this.contractorAddedToManager();
        this.$eventBus.emit(NOTIFICATION, Message.successMessage("Access has been granted"));
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      }
    }

    private setManagerAccessToContractor(contractorAddedToManagers: contractorAddedToManagers[]) {
      return this.$apollo.mutate({
        mutation: SET_MANAGER_ACCESSED_TO_CONTRACTOR,
        variables: {
          objects: contractorAddedToManagers,
        },
      });
    }
  }
